import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref');
  const { login, loading, error } = useAuthStore();

  const [formData, setFormData] = useState({
    studentId: '',
    password: '',
    autoLogin: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await login(formData.studentId, formData.password, formData.autoLogin);
    if (result.success) {
      navigate(refCode ? `/dashboard?ref=${refCode}` : '/dashboard');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-snow py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Bus animation */}
      <div className="absolute top-16 left-0 w-full pointer-events-none" style={{ animation: 'busRun 8s linear infinite' }}>
        <svg width="80" height="40" viewBox="0 0 80 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="8" width="70" height="24" rx="6" fill="#2B7FFF" />
          <rect x="10" y="12" width="12" height="10" rx="2" fill="#EBF3FF" />
          <rect x="26" y="12" width="12" height="10" rx="2" fill="#EBF3FF" />
          <rect x="42" y="12" width="12" height="10" rx="2" fill="#EBF3FF" />
          <rect x="58" y="12" width="12" height="10" rx="2" fill="#EBF3FF" />
          <circle cx="22" cy="34" r="5" fill="#1A1A2E" />
          <circle cx="58" cy="34" r="5" fill="#1A1A2E" />
          <circle cx="22" cy="34" r="2" fill="#8B8FA3" />
          <circle cx="58" cy="34" r="2" fill="#8B8FA3" />
        </svg>
      </div>

      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-card p-8 animate-fade-up">
          {/* Title */}
          <div className="mb-8 text-center">
            <h2 className="text-4xl font-extrabold text-tayo">
              타요버스
            </h2>
            <p className="mt-2 text-sm text-sub-text">
              대진대 버스 계정으로 로그인하세요
            </p>
          </div>

          <form className="space-y-5" onSubmit={handleSubmit}>
            {error && (
              <div className="rounded-xl bg-coral/10 p-4">
                <p className="text-sm text-coral">{error}</p>
              </div>
            )}

            <div className="space-y-3">
              <div>
                <label htmlFor="studentId" className="sr-only">
                  학번
                </label>
                <input
                  id="studentId"
                  name="studentId"
                  type="text"
                  autoComplete="username"
                  required
                  className="appearance-none relative block w-full px-4 py-3 border border-border placeholder-sub-text text-charcoal rounded-xl focus:outline-none focus:ring-2 focus:ring-tayo focus:border-tayo transition-colors sm:text-sm"
                  placeholder="학번"
                  value={formData.studentId}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  비밀번호
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="appearance-none relative block w-full px-4 py-3 border border-border placeholder-sub-text text-charcoal rounded-xl focus:outline-none focus:ring-2 focus:ring-tayo focus:border-tayo transition-colors sm:text-sm"
                  placeholder="비밀번호"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                id="autoLogin"
                name="autoLogin"
                type="checkbox"
                className="h-4 w-4 rounded border-border text-tayo focus:ring-tayo accent-tayo"
                checked={formData.autoLogin}
                onChange={handleChange}
              />
              <label htmlFor="autoLogin" className="ml-2 block text-sm text-charcoal">
                자동 로그인
              </label>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="btn-press group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-bold rounded-xl text-white bg-gradient-to-r from-tayo to-tayo-dark hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tayo disabled:opacity-50 disabled:cursor-not-allowed transition-shadow"
              >
                {loading ? '로그인 중...' : '로그인'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
